import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Instructor, InstructorValue } from '../models';

export const instructorActions = createActionGroup({
    source: 'Instructor',
    events: {
        // Get
        'Get Instructor': props<{ id: string }>(),
        'Get Instructor Success': props<{ payload: Instructor }>(),
        'Get Instructor Error': props<{ code: number }>(),
        // Create
        'Create Instructor': props<{ value: InstructorValue }>(),
        'Create Instructor Success': props<{ payload: Instructor }>(),
        'Create Instructor Error': props<{ code: number }>(),
        // Update
        'Update Instructor': props<{ id: string; value: InstructorValue }>(),
        'Update Instructor Success': props<{ payload: Instructor }>(),
        'Update Instructor Error': props<{ code: number }>(),
        // Delete
        'Delete Instructor': props<{ id: string }>(),
        'Delete Instructor Success': props<{ id: string }>(),
        'Delete Instructor Error': props<{ code: number }>(),
        // Clear
        Clear: emptyProps(),
    },
});
